<template>
    <div class="Man-CorretivaPrincipal">
        <PageTitle icon="fa fa-gear" main="Corretivas"
            sub="Manutenção Corretiva" />
        <div class="Man-CorretivaPrincipal">
            <b-card no-body>
                <b-tabs>                                        
                    <b-tab title="Corretiva" active><JbCorretivaLancamento /></b-tab>                                                                                                                        
                    <b-tab title="Indicadores" ><JbCorretivaPainel /></b-tab>                                                                                                                       
                    <b-tab title="Grupo" ><JbCorretivaGrupo /></b-tab>                                                                                                                        
                    <b-tab title="SubGrupo" ><JbCorretivaSubGrupo /></b-tab>                                                                                                                        
                    <b-tab title="Defeitos" ><JbCorretivaDefeitos /></b-tab>                                                                                                                        
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import JbCorretivaLancamento from '../sambaiba/JbManCorretivaLancamento'
import JbCorretivaPainel from '../sambaiba/JbManCorretivaPainel'
import JbCorretivaGrupo from '../sambaiba/JbManCorretivaGrupo'
import JbCorretivaSubGrupo from '../sambaiba/JbManCorretivaSubGrupo'
import JbCorretivaDefeitos from '../sambaiba/JbManCorretivaDefeitos'

export default {
    name: 'LinhaPrincipal',    
    components: { PageTitle, JbCorretivaLancamento, JbCorretivaPainel,JbCorretivaGrupo,JbCorretivaSubGrupo,JbCorretivaDefeitos}
    
}
</script>

<style>

</style>






